<template>
  <div class="bucket text-center">
    <a :href="url">
      <div class="img">
        <img :src="image" :alt="text" />
      </div>
      <div class="text ap-green">
        {{ text }}
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Bucket',
  props: {
    image: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: '#'
    }
  }
}
</script>

<style scoped>
.bucket {
  float: left;
  border: 1px solid #d7d7d7;
  display: block;
  height: 145px;
  margin: 0px 30px 10px 0px;
  font-size: 21px;
  width: 262px;
  padding: 5px;
}

.bucket > a {
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
}
</style>
